/**
 * Shared constants/helpers for cross-domain locale + location handoff.
 */

export const CROSS_DOMAIN_LOCALE_PARAM = 'cd_locale';
export const CROSS_DOMAIN_LOCATION_PARAM = 'cd_location';

export const CROSS_DOMAIN_LOCALE_OVERRIDE_KEY = 'cross_domain_locale_override';
export const CROSS_DOMAIN_LOCATION_OVERRIDE_KEY = 'cross_domain_location_override';

export const USER_LOCATION_STORAGE_KEY = 'user_location_state';
export const USER_LOCATION_STORAGE_VERSION = '4';
export const USER_LOCATION_STORAGE_VERSION_KEY = 'user_location_version';

export interface CrossDomainLocationState {
  location: string;
  source: 'user_selection';
  intentMode: 'local';
  targetLocation: null;
}

export function persistCrossDomainOverrides(locale?: string | null, locationId?: string | null): void {
  try {
    if (locale) {
      sessionStorage.setItem(CROSS_DOMAIN_LOCALE_OVERRIDE_KEY, locale);
    }

    if (locationId) {
      sessionStorage.setItem(CROSS_DOMAIN_LOCATION_OVERRIDE_KEY, locationId);
    }
  } catch {
    // Storage unavailable — non-fatal
  }
}

export function getCrossDomainLocaleOverride(): string | null {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get(CROSS_DOMAIN_LOCALE_PARAM) || sessionStorage.getItem(CROSS_DOMAIN_LOCALE_OVERRIDE_KEY);
  } catch {
    return null;
  }
}

export function getCrossDomainLocationOverride(): string | null {
  try {
    const params = new URLSearchParams(window.location.search);
    return params.get(CROSS_DOMAIN_LOCATION_PARAM) || sessionStorage.getItem(CROSS_DOMAIN_LOCATION_OVERRIDE_KEY);
  } catch {
    return null;
  }
}

export function clearCrossDomainLocaleOverride(): void {
  try {
    sessionStorage.removeItem(CROSS_DOMAIN_LOCALE_OVERRIDE_KEY);
  } catch {
    // Storage unavailable — non-fatal
  }
}

export function clearCrossDomainLocationOverride(): void {
  try {
    sessionStorage.removeItem(CROSS_DOMAIN_LOCATION_OVERRIDE_KEY);
  } catch {
    // Storage unavailable — non-fatal
  }
}

export function createCrossDomainLocationState(location: string): CrossDomainLocationState {
  return {
    location,
    source: 'user_selection',
    intentMode: 'local',
    targetLocation: null,
  };
}